import { useState } from "react"
import usePagination from "../../../hooks/usePagination"
import CreateOrUpdateIllustrationMappingsFacility from "./CreateOrUpdateIllustrationMappingFacility"
import IllustrationMappingsTable from "./IllustrationTable"
import DeleteIllustrationMappingFacility from "./DeleteIllustrationMappingFacility"
import { useIllustrationMappingsData } from "../../../hooks/useIllustrationMappings"
import ApiError from "../../../components/ApiError"

const MappingsTab = ({ mappingType }) => {
  const { limit, onPaginationChange, page, pagination } = usePagination()
  const [filters, setFilters] = useState([])
  const [openAddModal, setOpenAddModal] = useState(false)
  const [editedIllustrationMappingId, setEditedIllustrationMappingId] =
    useState(null)
  const [deleteIllustrationMappingId, setDeleteIllustrationMappingId] =
    useState(null)

  const { data, isLoading, isError, error } = useIllustrationMappingsData({
    endpoint: mappingType.endpoint,
    page,
    limit,
    filters,
  })

  const updateFilters = (data) => {
    // onPaginationChange({ ...pagination, pageIndex: 0 })
    setFilters(data)
  }

  const handleCloseDeleteModal = () => {
    setDeleteIllustrationMappingId(null)
  }

  const handleClose = () => {
    setEditedIllustrationMappingId(null)
    setOpenAddModal(false)
  }

  if (isError) {
    return (
      <div className="mt-4">
        <ApiError axiosError={error} />
      </div>
    )
  }

  return (
    <>
      <div className="px-4 pt-4 flex justify-end items-center">
        <button
          className="bg-secondary hover:bg-secondary_dark text-white py-2 px-3 rounded flex items-center gap-2"
          onClick={() => setOpenAddModal(true)}
        >
          Add {mappingType.label}
        </button>
      </div>
      <IllustrationMappingsTable
        data={isLoading ? [] : data?.data}
        filters={filters}
        loading={isLoading}
        mappingType={mappingType}
        pageCount={isLoading ? 0 : data?.pages}
        pagination={pagination}
        setDeleteIllustrationMappingId={setDeleteIllustrationMappingId}
        setEditedIllustrationMappingId={setEditedIllustrationMappingId}
        setFilters={updateFilters}
        onPaginationChange={onPaginationChange}
      />
      {(openAddModal || editedIllustrationMappingId) && (
        <CreateOrUpdateIllustrationMappingsFacility
          filters={filters}
          illustrationMappingId={
            editedIllustrationMappingId ? editedIllustrationMappingId : null
          }
          limit={limit}
          mappingType={mappingType}
          page={page}
          onClose={handleClose}
        />
      )}
      {deleteIllustrationMappingId && (
        <DeleteIllustrationMappingFacility
          filters={filters}
          illustrationMappingId={deleteIllustrationMappingId}
          limit={limit}
          mappingType={mappingType}
          page={page}
          onClose={handleCloseDeleteModal}
        />
      )}
    </>
  )
}

export default MappingsTab
